module.exports = __webpack_public_path__ + "static/img/son13.1051801c.jpg";